import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Link, Box } from '@mui/material';

const DeveloperCredit = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5 }}>
        <Link
          component="button"
          onClick={() => navigate('/privacy-policy')}
          sx={{ fontSize: '0.75rem', textDecoration: 'none', cursor: 'pointer', color: 'primary.main', '&:hover': { textDecoration: 'underline' }, bgcolor: 'transparent', border: 'none', fontFamily: 'inherit' }}
        >
          Privacy Policy
        </Link>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>|</Typography>
        <Link
          component="button"
          onClick={() => navigate('/terms-of-service')}
          sx={{ fontSize: '0.75rem', textDecoration: 'none', cursor: 'pointer', color: 'primary.main', '&:hover': { textDecoration: 'underline' }, bgcolor: 'transparent', border: 'none', fontFamily: 'inherit' }}
        >
          Terms of Service
        </Link>
      </Box>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
        &copy; {new Date().getFullYear()} RNHS Portal. All rights reserved.
      </Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
        Developed by{' '}
        <Link
          href="https://www.facebook.com/joshuasplazaofficial"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: 'primary.main', textDecoration: 'underline', '&:hover': { color: 'primary.dark' } }}
        >
          Joshua S. Plaza
        </Link>
      </Typography>
    </Box>
  );
};

export default DeveloperCredit;
